import { useState } from "react";
import { MGButton, SearchInput, SelectDropdown } from "../../../components";

// Third party
import { GridCsvExportOptions, useGridApiContext } from "@mui/x-data-grid";
import { FaEraser } from "react-icons/fa6";
import { Menu, MenuItem } from "@mui/material";
import { FiDownload } from "react-icons/fi";

export const AssignmentToolbar = ({
  searchParams,
  handleSearchParam,
  flightsOptions,
  handleSelectAirline,
  hotelOptions,
  handleSelectHotel,
  shipOptions,
  handleSelectShip,
  exportOptions,
  handleUnAssign,
  isUnassignEnable,
}: any) => {
  const apiRef = useGridApiContext();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleExportCsv = () => {
    const fileName = exportOptions?.fileName;
    const options: GridCsvExportOptions = {
      fileName: `${fileName}.csv`,
      delimiter: ",",
      allColumns: true,
      utf8WithBom: true,
    };
    apiRef.current?.exportDataAsCsv(options);
  };

  // Excel Export Handler
  const handleExportExcel = () => {
    const fileName = exportOptions?.fileName;
    const options: GridCsvExportOptions = {
      fileName: `${fileName}.xlsx`,
      delimiter: ",",
      utf8WithBom: true,
      allColumns: true,
    };

    if (apiRef?.current) {
      apiRef.current?.exportDataAsCsv(options);
    }
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="search-input">
      <SearchInput
        className="search-field"
        placeholder="Search..."
        value={searchParams}
        onChange={handleSearchParam}
      />

      <SelectDropdown
        containerClassName="mar-10"
        options={flightsOptions || []}
        isClearable
        name="selectflight"
        onChange={handleSelectAirline}
        placeholder="Select airline..."
      />

      <SelectDropdown
        containerClassName="mar-10"
        options={hotelOptions || []}
        isClearable
        name="selecthotel"
        onChange={handleSelectHotel}
        placeholder="Select hotel..."
      />

      <SelectDropdown
        containerClassName="mar-10"
        options={shipOptions || []}
        name="Selectship"
        isClearable
        onChange={handleSelectShip}
        placeholder="Select ship..."
      />

      <MGButton
        className="unassign-btn"
        onClick={handleUnAssign}
        disabled={isUnassignEnable}
      >
        <FaEraser className="unassign-icon" />
        Unassign
      </MGButton>

      <MGButton className="export-button" onClick={handleClick}>
        <FiDownload style={{ marginRight: 4 }} className="assign-icon" />
        <span>Export</span>
      </MGButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleExportCsv}>Download as CSV</MenuItem>
        <MenuItem onClick={handleExportExcel}>Download as Excel</MenuItem>
      </Menu>
    </div>
  );
};
